import {RANGOSCUENTA, TIPOSIMULACIONCONSULTOR} from "../../Constantes";

export const obtenerComisionConsultor = (datos, usuario) => {


    let dox = {}
    if (datos.tipo === TIPOSIMULACIONCONSULTOR[0].nombre) { //Venta directa
        dox = ventaDirecta(datos, usuario)
    } else {
        dox = ventaMiconsultor(datos, usuario)
    }

    return dox;

}


const ventaDirecta = (datos, usuario) => {

    let comisionVenta = 0
    if (usuario.rango === RANGOSCUENTA[0]) {//Consultor
        comisionVenta = 20
    } else {
        comisionVenta = 20 // 20% es la comision del vendedor
    }

    let impuesto = datos.impuesto

    let valorSinImpuesto = (datos.valor / ((impuesto / 100) + 1))
    let valorComisionVenta = obtenerValorPorcentaje(comisionVenta, valorSinImpuesto)
    let valorRecaudoDistribuidor = datos.valor - valorComisionVenta

    return {
        impuesto: impuesto,
        valorRecaudoDistribuidor: valorRecaudoDistribuidor,
        valorSinImpuesto: valorSinImpuesto,
        valorComisionVenta: valorComisionVenta,
        valorComisionConsultor: 0,
        valor: datos.valor,
        valorImpuesto: datos.valor - valorSinImpuesto
    }

}

const ventaMiconsultor = (datos, usuario) => {

    let comisionVenta = 0
    let comisionConsultor = 20

    if (usuario.rango === RANGOSCUENTA[0]) {//Consultor
        comisionVenta = 5
    } else {
        comisionVenta = 30
    }


    let impuesto = datos.impuesto

    let valorSinImpuesto = (datos.valor / ((impuesto / 100) + 1))
    let valorComisionVenta = obtenerValorPorcentaje(comisionVenta, valorSinImpuesto)
    let valorComisionConsultor = obtenerValorPorcentaje(comisionConsultor, valorSinImpuesto) // el porcentaje del consultor sera siempre el 20 %
    let valorRecaudoDistribuidor = datos.valor - valorComisionVenta - valorComisionConsultor

    return {
        impuesto: impuesto,
        valorRecaudoDistribuidor: valorRecaudoDistribuidor,
        valorSinImpuesto: valorSinImpuesto,
        valorComisionVenta: valorComisionVenta,
        valorComisionConsultor: valorComisionConsultor,
        valor: datos.valor,
        valorImpuesto: datos.valor - valorSinImpuesto

    }

}

function obtenerValorPorcentaje(porcentaje, total) {
    return (porcentaje / 100) * total;
}